import { combineReducers } from "redux";

import ui from "./reducers/ui";
import selectOptions from "./reducers/selectOptions";
import routes from "./reducers/routes"; // find a better way to handle this

const sharedReducers = combineReducers({
  ui: ui,
  selectOptions: selectOptions,
  routes: routes,
});

export default sharedReducers;



// WEBPACK FOOTER //
// ./src/features/shared/reducers.js